var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StatelessTags',{attrs:{"value":_vm.tags,"disabled":_vm.disabled},on:{"input":_vm.onInput,"tag-click":_vm.onTagClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }